var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_176828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 15.166H0.5V22.4986H7.8326V15.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 22.498H0.5V29.8306H7.8326V22.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 37.1699H0.5V44.5025H7.8326V37.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 44.502H0.5V51.8346H7.8326V44.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8326 51.834H0.5V59.1666H7.8326V51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1646 29.8301H7.83203V37.1627H15.1646V29.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1646 51.834H7.83203V59.1666H15.1646V51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 7.83203H15.1641V15.1646H22.4967V7.83203Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 15.166H15.1641V22.4986H22.4967V15.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 29.8301H15.1641V37.1627H22.4967V29.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4967 37.1699H15.1641V44.5025H22.4967V37.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8326 0.5H22.5V7.8326H29.8326V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8326 22.498H22.5V29.8306H29.8326V22.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8326 51.834H22.5V59.1666H29.8326V51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 7.83203H29.8281V15.1646H37.1607V7.83203Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 15.166H29.8281V22.4986H37.1607V15.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 22.498H29.8281V29.8306H37.1607V22.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 51.834H29.8281V59.1666H37.1607V51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1607 59.168H29.8281V66.5006H37.1607V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 0.5H37.1719V7.8326H44.5045V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 7.83203H37.1719V15.1646H44.5045V7.83203Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 22.498H37.1719V29.8306H44.5045V22.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 37.1699H37.1719V44.5025H44.5045V37.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 44.502H37.1719V51.8346H44.5045V44.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5045 59.168H37.1719V66.5006H44.5045V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 0.5H44.5V7.8326H51.8326V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 15.166H44.5V22.4986H51.8326V15.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 29.8301H44.5V37.1627H51.8326V29.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 44.502H44.5V51.8346H51.8326V44.502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8326 59.168H44.5V66.5006H51.8326V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 0.5H51.8359V7.8326H59.1685V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 15.166H51.8359V22.4986H59.1685V15.166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 37.1699H51.8359V44.5025H59.1685V37.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 51.834H51.8359V59.1666H59.1685V51.834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1685 59.168H51.8359V66.5006H59.1685V59.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5006 22.498H59.168V29.8306H66.5006V22.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5006 29.8301H59.168V37.1627H66.5006V29.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5006 37.1699H59.168V44.5025H66.5006V37.1699Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_176828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareIcon);
export default __webpack_public_path__ + "static/media/square-icon.babdc3f41c8fa16700a4b6529b26a8b7.svg";
export { ForwardRef as ReactComponent };